import React from 'react';
import PropTypes from 'prop-types';

// TODO styling
const UserSelect = (props) => (
  <div className="Register">
    <div className="Register__type">
      <input
        onChange={props.change}
        id="exhibitor"
        type="radio"
        name="type_of_user"
        value="exhibitor"
        required
      />
      Exhibitor
      <input
        onChange={props.change}
        id="visitor"
        type="radio"
        name="type_of_user"
        value="visitor"
        required
      />
      Trade Visitor
      <input
        onChange={props.change}
        id="press"
        type="radio"
        name="type_of_user"
        value="press"
        required
      />
      Press
      <input
        onChange={props.change}
        id="consumer"
        type="radio"
        name="type_of_user"
        value="consumer"
        required
      />
      Consumer
    </div>
  </div>
);

export default UserSelect;

UserSelect.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

UserSelect.defaultProps = {
  defaultVal: '',
};
